import clienteAxios from "../config/clienteAxios";

const updateNewService = async (id, newData) => {
  return await clienteAxios.patch(`/news/${id}`, newData);
};

export {
  updateNewService
}